import React from 'react';
import { ScrollLock } from '../modules/helpers/scrollLock';
import { render } from "../common/reactUtils";

const ScrollLocker = () => {
    ScrollLock.lock();

    return (<div id="scroll-lock"></div>);
}

export const initialize = () => {
    render(<ScrollLocker />, "#scroll-locker");
};